import auth from "@/auth/authService";

export default async function (to, from, next) {
    if (!requiresAuthentication(to)){
        return next();
    }

    if (!auth.isAuthenticated()) {
        var token = await auth.renewTokens().catch(() => {// eslint-disable-line
            auth.login({ target: to.fullPath });
        });
    }

    var permissionClaim = getPermissionClaim(to);

    if(permissionClaim !== null && !await auth.hasPermission(permissionClaim)){
        next({
            name: 'index'
        });
    }

    next();
}

let requiresAuthentication = function (to) {
    var lastPath = to.matched[to.matched.length - 1];
    return lastPath.meta == null || lastPath.meta.requiresAuthentication == null || lastPath.meta.requiresAuthentication;
}

let getPermissionClaim = function (to) {
    if (to.meta.permissionName != undefined) return to.meta.permissionName;

    const root = to.matched[0];

    var claim = null;
    if (root.meta.permissionPrefix != null) {
        claim = root.meta.permissionPrefix + ".";
    }
    else {
        claim = to.matched[0].path.slice(1) + ".";
    }

    if (to.meta.customPermission != null) {
        claim += to.meta.customPermission;
        return claim;
    }

    var nameWithoutDash = to.name.split("-").join("");
    var permissionArguments = nameWithoutDash.split(":");

    if (permissionArguments.length < 2) return null;

    claim += permissionArguments[0] + ".";

    switch (permissionArguments[1]) {
        case "index":
        case "detail":
            claim += "read";
            break;
        case "copy":
            claim += "create";
            break;
        default:
            claim += permissionArguments[1];
            break;
    }

    return claim;
}